import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/location-classes';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/location-classes';
import * as types from '../../../types/static-catalogs/location-classes';
import API_BASE_URL from '../../settings/apibaseurl';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchLocationClassesList(action) {
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/location/getLocationClasses`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { locationClasses },
          result //order
        } = normalize(resultData, schemas.locationClasses); //normalize data to byId and order
        yield put(actions.completeFetchingLocationClasses(locationClasses, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingLocationClasses(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingLocationClasses(error));
  }
}

export function* watchFetchLocationClassesList() {
  yield takeEvery(types.LOCATION_CLASSES_FETCH_STARTED, fetchLocationClassesList);
}
